<div class="find-tracks__search">
  <mat-form-field appearance="outline" bmTheme="find-tracks-input">
    <mat-label>{{ lg.sortTrackBy.tags.label }}</mat-label>
    <div class="find-tracks__input-box">
      <input
        matInput
        type="text"
        class="theme-inputMU__searchText"
        [(ngModel)]="searchTagTitle"
        (focus)="closeBeatmakerDropdown()"
        (ngModelChange)="changeTagsValue({ search: $event, searchType: 'tag' })"
      />
      @if (searchTagTitle) {
        <span class="btv-icon-close theme-inputMU__closeIcon" (click)="clearTagsField()"> </span>
      }
    </div>
  </mat-form-field>

  <!-- Tag search result dropdown -->
  @if (isTagDropdown) {
    <div class="find-tracks__response bm--scroll-bar theme-inputMU__resultsList">
      @for (tag of tags; track tag) {
        <ul>
          @if (tag.value !== '---') {
            <li class="theme-inputMU__resultsTag" (click)="findTracksByTag(tag.id, tag.value)">
              {{ '#' + tag.value }}
            </li>
          }
          @if (tag.value === '---') {
            <li class="not-found theme-inputMU__resultsNotFoundText">
              {{ lg.sortTrackBy.tags.notFound }}
            </li>
          }
        </ul>
      }
    </div>
  }
</div>
